<template>
  <div class="element-input element-complete">
    <div class="body">
      <div :class="{ on: true }" class="title">{{ data.title }}</div>
      <div class="label">{{ data.label }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ "data", "error" ],
  created () {
    let google_src = document.createElement('script')
    google_src.innerHTML = `gtag('event', 'conversion', {'send_to': 'AW-647230455/ynpcCJuqxs4BEPfnz7QC'});`;
    document.getElementById("site-header").appendChild(google_src)
  },
  methods: {
  }
}
</script>
